import React from "react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import { Switch } from "@mui/material";
import Button from "../../../../components/button";
import styles from "./styles.module.css";
import { LOCK_TOOLTIP_TEXT } from "../../../../utils/constants/last-price";
import useLastPriceHeader from "../../../../hooks/useLastPriceHeader";

registerLocale("es", es);

const OMIP_EMAIL_TOGGLE_TOOLTIP =
  "En esta pantalla, el interruptor no afecta al correo automático de precios con gráfica de LastPrice. Ese correo se envía siempre; el control se usa para el envío automático OMIP/OmiClear de las 18:15.";

const LastPriceHeader = ({
  props,
  startDate,
  setStartDate,
  handleClick,
  refresh,
  isEditingLocked,
  hasChanges,
  isSaving = false,
}) => {
  const {
    isEmailSet,
    isLoadingSendMib,
    isLoadingReRun,
    isLoadingReRunExcel,
    isLoadingEmail,
    handleClickSendMib,
    handleClickReRun,
    handleClickReRunExcel,
    handleSetEmailConfig,
    handleSendPricesEmail,
  } = useLastPriceHeader({ startDate, refresh });

  return (
    <div className={styles.header}>
      <div className={styles.titleRow}>
        <h3 className={styles.title}>Precio Último</h3>
        {props.isad && (
          <div className={styles.datepickerWrapper}>
            <DatePicker
              locale="es"
              dateFormat="dd/MM/yyyy"
              selected={startDate}
              onChange={setStartDate}
            />
          </div>
        )}
      </div>

      {props.isad ? (
        <div className={styles.controlsRow}>
          <div className={styles.leftControls}>
            <div className={styles.buttonGroup}>
              <span title={isEditingLocked ? LOCK_TOOLTIP_TEXT : ""}>
                <Button
                  variant="outline"
                  style={{ borderColor: "#40A382" }}
                  onClick={() => handleClick()}
                  disabled={isEditingLocked || !hasChanges}
                  isLoading={isSaving}
                >
                  Guardar Precios
                </Button>
              </span>
              <Button
                variant="outline"
                style={{ borderColor: "#9E2C10" }}
                title="Enviar a la Plataforma de MIBGAS"
                isLoading={isLoadingSendMib}
                onClick={() => handleClickSendMib(startDate)}
              >
                Enviar a MIBGAS
              </Button>
              <Button
                variant="outline"
                style={{ borderColor: "#DE7D07" }}
                title="Rejecutar el proceso de Precio Último"
                isLoading={isLoadingReRun}
                onClick={() => handleClickReRun(startDate)}
              >
                Rejecutar Proceso
              </Button>
              <Button
                variant="outline"
                style={{ borderColor: "#3965A8" }}
                title="Enviar Excel a OMIP y OmiClear"
                isLoading={isLoadingReRunExcel}
                onClick={() => handleClickReRunExcel(startDate)}
              >
                Enviar Excel
              </Button>
              <Button
                variant="outline"
                style={{ borderColor: "#6A5494" }}
                title="Enviar email con los precios"
                isLoading={isLoadingEmail}
                onClick={() => handleSendPricesEmail(startDate)}
              >
                Enviar Email Precios
              </Button>
            </div>
          </div>
          <div className={styles.emailConfig} title={OMIP_EMAIL_TOGGLE_TOOLTIP}>
            <span title={OMIP_EMAIL_TOGGLE_TOOLTIP}>
              Envío automático OMIP/OmiClear 18:15{" "}
              {isEmailSet ? "activado" : "desactivado"}{" "}
            </span>
            <span title={OMIP_EMAIL_TOGGLE_TOOLTIP}>
              <Switch checked={isEmailSet} onChange={handleSetEmailConfig} />
            </span>
          </div>
        </div>
      ) : (
        <div className={styles.controlsRowCenter}>
          <DatePicker
            locale="es"
            dateFormat="dd/MM/yyyy"
            selected={startDate}
            onChange={setStartDate}
          />
        </div>
      )}
    </div>
  );
};

export default LastPriceHeader;
